import { useState } from "react";
import { MessageCircle, X, Users } from "lucide-react";

const CHAT_URL = "https://wa.me/6282342302515?text=" + encodeURIComponent("Halo RESADA, saya butuh bantuan 🙂");
const COMMUNITY_URL = "https://chat.whatsapp.com/CwROTH1TJUoG5X9PJrkDQz?mode=gi_t";

export default function FloatingWhatsApp() {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-24 right-5 z-50 flex flex-col items-end gap-3" data-testid="floating-wa">
      {open && (
        <div className="w-64 rounded-2xl bg-white shadow-2xl shadow-slate-300/50 border border-slate-100 overflow-hidden animate-float-up">
          <div className="bg-[#25D366] px-4 py-3 text-white">
            <p className="font-display font-bold text-sm">Butuh bantuan?</p>
            <p className="text-[11px] text-white/90">Tim kami siap membantu via WhatsApp.</p>
          </div>
          <div className="p-2">
            <a href={CHAT_URL} target="_blank" rel="noreferrer" data-testid="wa-chat-admin"
              className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-emerald-50 transition group">
              <span className="w-9 h-9 rounded-full bg-emerald-100 grid place-items-center"><MessageCircle className="w-5 h-5 text-emerald-600" /></span>
              <span className="min-w-0">
                <span className="block text-sm font-semibold text-slate-800">Chat Admin</span>
                <span className="block text-[11px] text-slate-400">0823-4230-2515</span>
              </span>
            </a>
            <a href={COMMUNITY_URL} target="_blank" rel="noreferrer" data-testid="wa-join-community"
              className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-sky-50 transition group">
              <span className="w-9 h-9 rounded-full bg-sky-100 grid place-items-center"><Users className="w-5 h-5 text-sky-600" /></span>
              <span className="min-w-0">
                <span className="block text-sm font-semibold text-slate-800">Gabung Komunitas</span>
                <span className="block text-[11px] text-slate-400">Tips & update terbaru</span>
              </span>
            </a>
          </div>
        </div>
      )}
      <button onClick={() => setOpen((v) => !v)} data-testid="floating-wa-toggle"
        className="w-14 h-14 rounded-full bg-[#25D366] grid place-items-center shadow-lg shadow-emerald-300/50 hover:scale-105 active:scale-95 transition-transform">
        {open ? <X className="w-6 h-6 text-white" /> : <MessageCircle className="w-7 h-7 text-white" fill="white" />}
      </button>
    </div>
  );
}
